<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item>个人赛考务管理</el-breadcrumb-item>
            <!-- <el-breadcrumb-item>初选成绩查询</el-breadcrumb-item> -->
            <el-breadcrumb-item>答题详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack"></el-page-header>
        <template v-if="formData.season === '2022~2023'">
            <div v-for="(item, index) in answerResultData" :key="index">
                <el-card style="margin-top: 15px">
                    <el-descriptions border>
                        <el-descriptions-item label="当前赛季">{{
                            item.season
                        }}</el-descriptions-item>
                        <el-descriptions-item label="答题状态">
                            <template>
                                <el-tag
                                    type="danger"
                                    v-if="item.answerStatus === 2"
                                    size="mini"
                                    >进行中</el-tag
                                >
                                <el-tag
                                    type="success"
                                    v-else-if="item.answerStatus === 1"
                                    size="mini"
                                    >已完成</el-tag
                                >
                                <span v-else>-</span>
                            </template></el-descriptions-item
                        >
                        <el-descriptions-item label="本轮成绩"
                            ><span style="color: orange">{{
                                item.score
                            }}</span></el-descriptions-item
                        >
                    </el-descriptions>
                    <el-table
                        header-cell-class-name="tableHeaderStyle"
                        :data="item.resultList"
                        :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }"
                        border
                        stripe
                    >
                        <el-table-column
                            label="序号"
                            type="index"
                        ></el-table-column>
                        <el-table-column
                            label="用户答案"
                            prop="userAnswer"
                        ></el-table-column>
                        <el-table-column
                            label="系统答案"
                            prop="questionAnswer"
                        ></el-table-column>
                        <el-table-column label="是否正确" type="isRight">
                            <template slot-scope="scope">
                                <el-tag
                                    type="success"
                                    v-if="scope.row.isRight === '1'"
                                    size="mini"
                                    >正确</el-tag
                                >
                                <el-tag
                                    type="danger"
                                    v-else-if="scope.row.isRight === '0'"
                                    size="mini"
                                    >错误</el-tag
                                >
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </div>
        </template>
        <template v-else>
            <el-card
                v-if="formData.activeRound == '1' || formData.activeRound == '4' || formData.activeRound == '6'"
                style="margin-top: 15px"
            >
                <el-descriptions border>
                    <el-descriptions-item label="当前赛季">{{
                        formData.season
                    }}</el-descriptions-item>
                    <el-descriptions-item label="选手姓名">{{
                        formData.userName
                    }}</el-descriptions-item>
                    <el-descriptions-item label="选手成绩"
                        ><span style="color: orange">{{
                            formData.score
                        }}</span></el-descriptions-item
                    >
                </el-descriptions>
                <el-table
                    header-cell-class-name="tableHeaderStyle"
                    :data="paperData"
                    stripe
                    border
                >
                    <el-table-column
                        prop="quizNumber"
                        label="题号"
                        width="100px"
                    >
                    <template slot-scope="scope">
                        <el-tag type="primary" size="small" effect="dark" v-if="scope.row.quizForm === 1">例题</el-tag>
                        <el-tag type="danger" size="small" effect="dark" v-if="(scope.row.formQuizInfo && scope.row.formQuizInfo.isStandby) || scope.row.isStandby" style="font-size: 12px;">备用{{
                                scope.row.quizNumber
                            }}</el-tag>
                            <span class="font" v-else>{{
                                scope.row.quizNumber
                            }}</span>
                    </template>
                </el-table-column>
                    <el-table-column prop="quizType" label="题型">
                        <template slot-scope="scope">
                            <el-tag
                                :type="
                                    scope.row.quizType === 1
                                        ? 'warning'
                                        : scope.row.quizType === 2
                                        ? 'success'
                                        : 'danger'
                                "
                            >
                                {{
                                    scope.row.quizType === 1
                                        ? "题型A"
                                        : scope.row.quizType === 2
                                        ? "题型B"
                                        : "题型C"
                                }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="正确答案">
                        <template slot-scope="scope">
                            <template v-if="scope.row.quizType === 3">
                                <img
                                    class="answer-img"
                                    :src="scope.row.answer"
                                    alt=""
                                />
                            </template>
                            <template v-else>
                                <span class="font">{{ scope.row.answer }}</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="用户答案">
                        <template slot-scope="scope">
                            <template v-if="scope.row.quizType === 3">
                                <img
                                    class="answer-img"
                                    :src="scope.row.formQuizMatchInfo.userAnswer"
                                    alt=""
                                />
                            </template>
                            <template v-else-if="scope.row.quizForm !== 1">
                                <span class="font">{{
                                    scope.row.formQuizMatchInfo.userAnswer
                                }}</span>
                            </template>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="用户答案" v-else>
                        <template slot-scope="scope">
                            <template v-if="scope.row.quizType === 3">
                                <img
                                    class="answer-img"
                                    :src="scope.row.userAnswer"
                                    alt=""
                                />
                            </template>
                            <template v-else>
                                <span class="font">{{
                                    scope.row.userAnswer
                                }}</span>
                            </template>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="formQuizMatchInfo.userScore" label="得分">
                        <template slot-scope="scope">
                            <span v-if="scope.row.quizForm !== 1">{{ scope.row.formQuizMatchInfo.userScore }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="formQuizMatchInfo.times" label="用时/秒">
                        <template slot-scope="scope">
                            <span v-if="scope.row.quizForm !== 1">{{ scope.row.formQuizMatchInfo.times }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="userScore" label="判定">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.quizForm !== 1"
                                :type="
                                    scope.row.formQuizMatchInfo.userScore == 0
                                        ? 'danger'
                                        : 'success'
                                "
                                size="mini"
                                >{{
                                    scope.row.formQuizMatchInfo.userScore == 0 ? "错误" : "正确"
                                }}</el-tag
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <el-card
                v-else-if="formData.activeRound == '2' || formData.activeRound == '3'"
                style="margin-top: 15px"
            >
                <el-descriptions border>
                    <el-descriptions-item label="当前赛季">{{
                        formData.season
                    }}</el-descriptions-item>
                    <el-descriptions-item label="选手姓名">{{
                        formData.userName
                    }}</el-descriptions-item>
                    <el-descriptions-item label="选手成绩"
                        ><span style="color: orange">{{
                            formData.score
                        }}</span></el-descriptions-item
                    >
                </el-descriptions>
                <el-table
                    header-cell-class-name="tableHeaderStyle"
                    :data="paperData"
                    stripe
                    border
                >
                    <!-- <el-table-column
                        prop="quizNumber"
                        label="题号"
                        width="60px"
                    ></el-table-column> -->

                    <el-table-column
                        prop="quizNumber"
                        label="题号"
                        width="100px"
                    >
                    <template slot-scope="scope">
                        <el-tag type="danger" v-if="scope.row.isStandby" style="font-size: 12px;">备用{{
                                scope.row.quizNumber
                            }}</el-tag>
                            <span class="font" v-else>{{
                                scope.row.quizNumber
                            }}</span>
                    </template>
                </el-table-column>
                    <el-table-column prop="quizType" label="题型">
                        <template slot-scope="scope">
                            <el-tag
                                :type="
                                    scope.row.quizType === 1
                                        ? 'warning'
                                        : scope.row.quizType === 2
                                        ? 'success'
                                        : 'danger'
                                "
                            >
                                {{
                                    scope.row.quizType === 4
                                        ? "魔力部件"
                                        : (scope.row.quizType === 5 ? "极速拼字": "九宫格")
                                }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="正确答案">
                        <template slot-scope="scope">
                            <template v-if="scope.row.quizType === 3">
                                <img
                                    class="answer-img"
                                    :src="scope.row.answer"
                                    alt=""
                                />
                            </template>
                            <template v-else>
                                <span class="font">{{ scope.row.answer }}</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="用户答案">
                        <template slot-scope="scope">
                            <template
                                v-if="
                                    scope.row.nationalGroupFormAnswerVo &&
                                    scope.row.nationalGroupFormAnswerVo.answer
                                "
                            >
                                <span class="font">{{
                                    scope.row.nationalGroupFormAnswerVo.answer
                                }}</span>
                            </template>
                            <template v-else>
                                <span class="font">-</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column prop="userScore" label="得分">
                       <template slot-scope="scope">
                            <template
                                v-if="scope.row.nationalGroupFormAnswerVo"
                            >
                                <span class="font">{{
                                    scope.row.nationalGroupFormAnswerVo.score
                                }}</span>
                            </template>
                            <template v-else>
                                <span class="font">0</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nationalGroupFormAnswerVo.times" label="用时/秒"></el-table-column>
                    <el-table-column prop="userScore" label="判定">
                        <template slot-scope="scope">
                            <template
                                v-if="!scope.row.nationalGroupFormAnswerVo"
                            >
                                <el-tag type="info" size="mini">未作答</el-tag>
                            </template>
                            <template
                                v-else
                            >
                                <el-tag
                                    :type="
                                        scope.row.nationalGroupFormAnswerVo.score == 0
                                            ? 'danger'
                                            : 'success'
                                    "
                                    size="mini"
                                    >{{
                                        scope.row.nationalGroupFormAnswerVo.score == 0 ? "错误" : "正确"
                                    }}</el-tag
                                >
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column prop="isDiscard" label="是否弃用">
                       <template slot-scope="scope">
                            <template
                                v-if="scope.row.isDiscard"
                            >
                                <el-tag type="danger" size="mini">弃用</el-tag>
                            </template>
                            <template v-else>
                                <span class="font"></span>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </template>
    </div>
</template>

<script>

import { getAnswerRaceScheduleByUserId } from '@/http/api'

export default {
  data () {
    return {
      dataList: [],
      answerResultData: [],
      formData: JSON.parse(this.$route.query.formDataStr),
      paperData: []
    }
  },
  created () {
    this.seasonHandleChange()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    seasonHandleChange () {
      console.log('formData===', this.formData)
      if (this.formData.season === '2022~2023') {
        getAnswerRaceScheduleByUserId(this.formData).then((res) => {
          console.log('getSchoolList', res)
          this.answerResultData = res.data.map(item => {
            item.resultList = JSON.parse(item.results)
            return item
          })
          console.log('answerResultData', this.answerResultData)
        }).catch((err) => {
          console.log('返回的err', err)
        })
      } else {
        console.log(this.formData)
        // activeRound:6 25-26赛季初选前端为了看答题详情写死的，由上一个页面schedule_individual_competition.vue传进来的，如果值冲突可以改
        if (this.formData.activeRound === '1' || this.formData.activeRound === '4' || this.formData.activeRound === '6') {
          this.$http.get('form/queryTheOnlineFormAnswerInfo', { params: { matchResultId: this.formData.matchResultId } }).then(res => {
            if (res.code === 200) {
              this.paperData = res.data
            }
          })
        } else if (this.formData.activeRound === '2' || this.formData.activeRound === '3') {
          const url1 = 'national/selectTwoUserAnswerInfo'
          const url2 = 'examination/selectTwoUserAnswerInfo'
          const url = this.formData.isNational ? url1 : url2
          console.log(this.formData)
          const formData1 = {
            // id: this.formData.id,
            // phase: this.formData.activeRound,
            // raceSchedule: this.formData.raceSchedule,
            userId: this.formData.userId,
            season: this.formData.season,
            raceSchedule: this.formData.raceSchedule,
            phase: this.formData.activeRound,
            level: this.formData.level,
            isGroup: this.formData.isGroup
          }
          const formData2 = {
            id: this.formData.id,
            phase: this.formData.activeRound,
            raceSchedule: this.formData.raceSchedule,
            userId: this.formData.userId
          }
          console.log(formData1)
          const formData = this.formData.isNational ? formData1 : formData2
          this.$http.get(url, { params: formData }).then(res => {
            if (res.code === 200) {
              this.paperData = res.data
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.answer-img {
    width: 40px;
}
</style>
